import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, mergeProps as _mergeProps } from "vue"

import { ref, onMounted, watch, computed } from 'vue'
import { listByUsers, fetchUsersByWorkCode } from '@/api/common'
import { debounce, differenceBy, uniqBy } from 'lodash-es'
import { useRequest } from 'vue-request'

const __default__ = { name: 'BatchUserList' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: [String, Number, Array]
  },
  label: {
    type: [String, Number]
  },
  mode: {
    type: String
  }
},
  emits: ['update:value', 'update:label', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props
const data = ref()
const userselect = ref()
const emit = __emit
const optionPage = ref<any[]>([])
const pageNumber = ref(1)
const searchTxt = ref('')
const valueList = ref<any[]>([])
const change = (value: any) => {
  const record = optionPageComputed.value.find((item: any) => item.employeeNo === value)
  emit('update:value', value)
  emit('update:label', record?.userName)
  emit('change', record)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const optionPageComputed = computed(() => {
  if (searchTxt.value) {
    return optionPage.value
  }
  return uniqBy([...valueList.value, ...optionPage.value], 'employeeNo')
})
// 是否请求接口
const needFetchValue = (v: any[]) => {
  if (v && v.length) {
    const vL = v.map((v) => {
      return {
        employeeNo: v
      }
    })
    const valueArr = differenceBy(vL, optionPage.value, 'employeeNo')
    if (valueArr) {
      if (searchTxt.value) {
        fetchUser('')
      }
      // 判断是否有label
      if (v.length === 1) {
        if (v[0] === props.value && props.label) {
          valueList.value = [{ userName: props.label, employeeNo: props.value }]
          return
        }
      }
      const employeeList = valueArr.map((item: any) => item.employeeNo)
      fetchUsersByWorkCode({
        employeeList
      }).then((res) => {
        valueList.value = res.data || []
      })
    }
  }
}
onMounted(() => {
  initFetch()
})
const fetchUser = debounce((txt: string) => {
  // 去掉前后空格
  searchTxt.value = txt.trim()
  optionPage.value = []
  pageNumber.value = 1
  fetch()
}, 500)
const initFetch = () => {
  const p = {
    pageNumber: 1,
    pageSize: 100,
    dataRangeQueryFlag: false
  }
  useRequest(listByUsers, {
    defaultParams: [p],
    cacheKey: JSON.stringify(p),
    onSuccess: (res) => {
      optionPage.value = [...optionPage.value, ...res.data.items]
    }
  })
}
const fetch = () => {
  listByUsers({
    pageNumber: pageNumber.value,
    pageSize: 100,
    dataRangeQueryFlag: false,
    keyword: searchTxt.value
  }).then((res) => {
    if (pageNumber.value === 1) {
      optionPage.value = []
    }
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
watch(
  () => props.value,
  (v) => {
    if (!v) {
      data.value = v
      // 处理搜索
      if (searchTxt.value) {
        fetchUser('')
      }
    } else if (typeof v === 'string' && v !== data.value) {
      data.value = v
      needFetchValue([v])
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, _mergeProps(_ctx.$attrs, {
    value: data.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
    mode: __props.mode,
    style: {"width":"100%"},
    ref_key: "userselect",
    ref: userselect,
    onChange: change,
    allowClear: "",
    onPopupScroll: popupScroll,
    showSearch: true,
    "filter-option": false,
    onSearch: _unref(fetchUser),
    placeholder: "请选择"
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPageComputed.value, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: item.employeeNo,
          value: item.employeeNo
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(`${item.userName}(${item.employeeNo})`), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 16, ["value", "mode", "onSearch"]))
}
}

})